import React, { useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";

import { AnimatePresence, motion } from "framer-motion";
import { ReactComponent as BlankImg } from "../../assets/imgs/blankImg.svg";
import InfoDropdown from "../Fold2/InfoDropdown";

const OptimizePerformance = () => {
  const goToBenefits = () => {
    let element = document.getElementById("benefits");
    element.scrollIntoView({ behavior: "smooth" });
  };

  const dropdownList = [
    {
      id: 0,
      dropdownTitle: "Link Performance",
      title:
        "Track installs, opens, reactivations, and engagement for each individual link.",
      text: "Understand how every link performs across your campaigns. See which links bring users into the app, re-engage dormant users, or lead to longer in-app sessions. Use this insight to fine-tune your messaging and targeting.",
      learnMore: "",
    },
    {
      id: 1,
      dropdownTitle: "Campaign Comparison",
      title:
        "Compare the success of different campaigns by channel, platform, or time period.",
      text: "Quickly identify your top-performing campaigns by measuring installs, re-engagements, click-throughs, and other KPIs. View side-by-side results across Android, iOS, and Web to know where to invest next.",
      learnMore: "",
    },
    {
      id: 2,
      dropdownTitle: "User-Level Insights",
      title: "Get a full picture of individual user behavior and impact.",
      text: "See who opened what, when they were last active, how many people they referred, and which links they shared. Gain clarity on your most valuable users and ambassadors to better support retention and viral growth.",
      learnMore: "",
    },
    {
      id: 3,
      dropdownTitle: "Referral Tracking",
      title: "See who’s driving your app’s growth and how.",
      text: "Monitor referral chains to track how users share your app. For every user-generated link, view total installs, app opens, link clicks, and re-installs. Understand how word-of-mouth spreads through your network.",
      learnMore: "",
    },
    {
      id: 4,
      dropdownTitle: "Flexible Dashboards & Filters",
      title:
        "Get a clear view of performance with customizable filters and metrics.",
      text: "Use intuitive dashboards to see key metrics like installs, re-installs, activations, and engagement—broken down by platform (iOS, Android, Web), source, campaign, or time period. Easily filter data to uncover trends, compare performance, and make faster, data-driven decisions.",
      learnMore: "",
    },
  ];

  return (
    <FullPageContainer>
      <Container id={"optimizePerformance"}>
        <Line>
          <TextWrapper>
            <Title>
              Track, Compare, and Optimize Performance Across All Platforms and
              Campaigns
            </Title>
            <Subtitle>
              Gain full visibility into installs, re-installs, activations, and
              more—customized to your unique needs. Quickly analyze and optimize
              your efforts with clear, actionable insights.
            </Subtitle>
          </TextWrapper>
        </Line>
        <AnimatePresence>
          <Line>
            <Column>
              {dropdownList.map((item) => (
                <InfoDropdown
                  key={item.id}
                  dropdownTitle={item.dropdownTitle}
                  title={item.title}
                  infoText={item.text}
                  learnMoreClick={item.learnMore}
                />
              ))}
            </Column>
          </Line>
        </AnimatePresence>
      </Container>
    </FullPageContainer>
  );
};

export default OptimizePerformance;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 0px 80px 100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  margin: auto;
  @media (max-width: 990px) {
    max-width: unset;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;

const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

const Line = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 25px;
  width: 100%;
  overflow: hidden;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "initial")};

  @media (max-width: 990px) {
    gap: 10px;
    flex-direction: column;
  }
`;

const Column = styled(motion.div)`
  display: flex;
  flex-direction: column;
    align-items:center;
  width: 100%;
  gap: 16px;
`;
